const _PHP = window._PHP;
const vehicles = [];

// fix _PHP.vehicles -> to array

for (var v in _PHP.vehicles) {
  if (_PHP.vehicles.hasOwnProperty(v)) {
    vehicles.push(_PHP.vehicles[v]);
  }
}
window._PHP.vehicles = _PHP.vehicles = vehicles;

export default _PHP;
